module.exports = __webpack_public_path__ + "img/primeng-stencil.515abc54.svg";